import { withOptionsEndpoint } from "@dgs/core";
import { OrganizationalUnitOptionResource } from "../types/organizationalUnit";

const baseKey = ["organizational-units"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const organizationalUnitService = {
	...withOptionsEndpoint<OrganizationalUnitOptionResource>(baseKey),
	quickFilterKey,
};
